import { useMsal } from '@azure/msal-react'

import { useUserQuery } from 'queries/useUserQuery'

import Lightbulb from '../../assets/images/miniBanner/lightbulb.gif'

export const MiniBannerData = () => {
  const { accounts } = useMsal()
  const { data: userProfile } = useUserQuery()

  // accounts[0].name is the display name from Azure AD
  const firstName = userProfile?.firstName ?? accounts[0]?.name?.split(' ')[0] ?? ''

  // avatarUrl not available in MSAL — falls back to empty string same as before
  // can be populated from userProfile if your API returns it
  const avatarUrl = '' // userProfile?.avatarUrl ?? ''

  return [
    {
      img: avatarUrl,
      title: 'Update your profile',
      description: 'Update now and get matched to projects best suited to your skills and experience.',
      backgroundColor: '#680101',
      button: {
        text: 'Go to Experience Profile',
        link: process.env.REACT_APP_UPDATE_PROFILE_LINK ?? '',
      },
      event_type: 'pg_act_ourwork_banner_gotoexperienceprofile',
      name: firstName,
      isMarketingFocused: true,
    },
    {
      img: Lightbulb,
      title: 'Chime in!',
      description: "Have an idea for a new project? We can't wait to hear all about it.",
      backgroundColor: '#400103',
      button: {
        text: 'Suggest New Project',
        link: process.env.REACT_APP_SUGGEST_NEW_PROJECT_LINK ?? '',
      },
      event_type: 'pg_act_ourwork_banner_suggestnewproject',
      isMarketingFocused: false,
    },
  ]
}
